import { render } from "./WalletTransaction.vue?vue&type=template&id=66d44fd5&scoped=true"
import script from "./WalletTransaction.vue?vue&type=script&lang=js"
export * from "./WalletTransaction.vue?vue&type=script&lang=js"

import "./WalletTransaction.vue?vue&type=style&index=0&id=66d44fd5&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3818363008/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d44fd5"]])

export default __exports__